module.exports = __webpack_public_path__ + "img/logo-white.5c6209c1.svg";